import PLANS from './plans.json';
import { FREE_PLAN_IDS } from '../components/plans/PlanCardsGrid';

// Real gate, not a guess — matches UNLIMITED_EMOTIONAL_PLANS in constants.js (light + full
// plan families get unlimited emotional voice generations; free/starter are limited).
const EMOTIONAL_UNLIMITED_FAMILIES = ['light', 'full'];

export const getComparePlans = () => {
  const free = PLANS.find((p) => FREE_PLAN_IDS.includes(p.plan_id_usd));
  const paid = PLANS.filter((p) => p.is_active && !FREE_PLAN_IDS.includes(p.plan_id_usd));
  return [free, ...paid].filter(Boolean);
};


export const COMPARE_CATEGORIES = [
  { id: 'overview', label: 'Overview' },
  { id: 'voice', label: 'Voice & Audio' },
];

// Studio-projects cap per plan_family — free is capped at 1 project, every paid tier is
// unlimited (matches the "Unlimited Projects" feature line on starter/light/full in plans.json).
const PROJECTS_BY_FAMILY = { free: '1', starter: 'Unlimited', light: 'Unlimited', full: 'Unlimited' };

// Paid-only feature gates, keyed by plan_family rather than position — getComparePlans()'s
// output order/length tracks which plans are is_active in plans.json, so a positional
// [false, true, true, true] array would silently misattribute rows if that set ever changes
// (e.g. a plan gets reactivated or a new tier is added).
const PAID_ONLY_FAMILIES = ['starter', 'light', 'full'];
const isPaidOnlyFamily = (family) => PAID_ONLY_FAMILIES.includes(family);

/**
 * Builds the Overview/Voice row sets for the given plans (output of getComparePlans()).
 * Credits/month and Stored audios are read straight off each plan's `words_count` /
 * `articles_count` fields so they can't drift from plans.json; the rest are feature-flag rows
 * hand-authored from the same file's `features`/`summary_features` text, keyed by plan_family.
 */
export const getCompareRows = (plans) => ({
  overview: [
    { label: 'Credits / month', values: plans.map((p) => (p.words_count ?? 0).toLocaleString()) },
    { label: 'Studio projects', values: plans.map((p) => PROJECTS_BY_FAMILY[p.plan_family] ?? '—') },
    { label: 'Stored audios', values: plans.map((p) => (p.articles_count ?? 0).toLocaleString()) },
    { label: 'Downloads', values: plans.map((p) => isPaidOnlyFamily(p.plan_family)) },
    { label: 'Commercial use', values: plans.map((p) => isPaidOnlyFamily(p.plan_family)) },
  ],
  voice: [
    { label: '900+ premium voices', values: plans.map((p) => isPaidOnlyFamily(p.plan_family)) },
    { label: 'Unlimited previews', values: plans.map(() => true) },
    { label: 'Voiceover studio access', values: plans.map(() => true) },
    {
      label: 'Emotional voice generation',
      values: plans.map((p) => (EMOTIONAL_UNLIMITED_FAMILIES.includes(p.plan_family) ? 'Unlimited' : 'Limited')),
    },
  ],
});
